module.exports = __webpack_public_path__ + "static/media/title_bg_12.52b1bf48.png";